<template>
  <div class="currency_rate">
    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col">
              {{ translate('invoice.date_month') }}
            </th>
            <th scope="col">
              {{ translate('invoice.date') }}
            </th>
<!--            <th scope="col">-->
<!--              {{ translate('invoice.rate_day') }}-->
<!--            </th>-->
            <th scope="col">
              {{ translate('invoice.currency') }}
            </th>
            <th scope="col">
              {{ translate('invoice.value') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(currency_rate, key) in currency_rate_list" :key="key" class="currency">
            <td :data-label="translate('invoice.date_month')">
              {{ currency_rate.date_month }}
            </td>
            <td :data-label="translate('invoice.date')">
              {{ currency_rate.date }}
            </td>
<!--            <td :data-label="translate('invoice.rate_day')">-->
<!--              {{ currency_rate.rate_day }}-->
<!--            </td>-->
            <td :data-label="translate('invoice.currency')">
              {{ currency_rate.currency }}
            </td>
            <td :data-label="translate('invoice.value')" class="value">
              {{ (currency_rate.value).toFixed(4) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'CurrencyRate',
  components: {
    WrapDatePicker,
  },
  data () {
    return {
      currency_rate_list: []
    }
  },

  created () {
    this.load_currency_rate()
  },

  methods: {
    load_currency_rate(){
      this.$http.v1.getCurrencyRate({}, (response) => {
        if (response.data){
          this.currency_rate_list = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.currency_rate{
  height: 100%;
  .response_table{
    padding: 0;
  }
  .currency{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
    .value{
      text-align: right;
      padding-right: 20px;
    }
  }
}
</style>
